/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ClientConfigurationDormerSpecificSettingsClientVariableSettingsDto } from "./ClientConfigurationDormerSpecificSettingsClientVariableSettingsDto";

export class ClientConfigurationDormerSpecificSettingsDto {
    id: string;
    clientConfigurationId: string;
    clientVariableSettings: ClientConfigurationDormerSpecificSettingsClientVariableSettingsDto;
}
